import React from 'react';
import styles from './ShareGallery.module.css';

const galleryItems = [
  {
    id: '01',
    label: 'Workout Plan',
    title: 'Morning Plan Card',
    image: '/eveningCard.jpeg',
    alt: 'LeanWeek workout plan share card preview',
  },
  {
    id: '02',
    label: 'Evening Results',
    title: 'Daily Recap Card',
    image: '/mondayRecap.jpeg',
    alt: 'LeanWeek daily recap share card preview',
  },
  {
    id: '03',
    label: 'High Adherence',
    title: 'Performance Summary Card',
    image: '/wednesdayEveningCard.jpeg',
    alt: 'LeanWeek performance summary share card preview',
  },
];

const ShareGallery = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.kicker}>Shareable Outputs</span>

          <h2 className={styles.title}>
            Progress worth <span>showing off.</span>
          </h2>

          <p className={styles.subtitle}>
            Export polished LeanWeek share cards for workouts, daily recaps, and
            performance summaries — ready for saving, sharing, or posting.
          </p>
        </div>

        <div className={styles.galleryGrid}>
          {galleryItems.map((item) => (
            <article key={item.id} className={styles.galleryCard}>
              <div className={styles.cardTop}>
                <span className={styles.previewLabel}>{item.label}</span>
                <span className={styles.previewIndex}>{item.id}</span>
              </div>

              <div className={styles.imageFrame}>
                <img
                  src={item.image}
                  alt={item.alt}
                  className={styles.galleryImage}
                  loading="lazy"
                />
              </div>

              <div className={styles.cardBottom}>
                <h3 className={styles.cardTitle}>{item.title}</h3>
                <p className={styles.cardMeta}>Saved from LeanWeek share exports</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ShareGallery;